(() => {
  const root = document.querySelector('[data-pino-support]');
  if (!root) return;
  const search = root.querySelector('[data-psu-search]');
  const clear = root.querySelector('[data-psu-clear]');
  const status = root.querySelector('[data-psu-search-status]');
  const questions = Array.from(root.querySelectorAll('[data-psu-question]'));
  const groups = Array.from(root.querySelectorAll('[data-psu-group]'));
  const normalize = value => value.normalize('NFKC').toLocaleLowerCase('ja').replace(/[\s　]+/g, ' ').trim();
  const originalOpen = new Map();
  let filtering = false;
  const filter = () => {
    const words = normalize(search.value).split(' ').filter(Boolean);
    if (words.length && !filtering) questions.forEach(item => originalOpen.set(item, item.open));
    let count = 0;
    questions.forEach(item => {
      const text = normalize(item.textContent);
      const matches = words.every(word => text.includes(word));
      item.hidden = !matches;
      if (words.length) item.open = matches;
      else if (filtering) item.open = originalOpen.get(item) || false;
      if (matches) count += 1;
    });
    groups.forEach(group => { group.hidden = !Array.from(group.querySelectorAll('[data-psu-question]')).some(item => !item.hidden); });
    root.querySelector('[data-psu-no-results]').hidden = count > 0;
    clear.hidden = !search.value;
    status.textContent = words.length ? status.dataset.countTemplate.replace('%count%', String(count)) : '';
    filtering = words.length > 0;
  };
  const reset = () => { search.value = ''; filter(); search.focus(); };
  search.addEventListener('input', filter);
  search.addEventListener('search', filter);
  clear.addEventListener('click', reset);
  root.querySelector('[data-psu-reset]').addEventListener('click', reset);
  root.querySelector('[data-psu-search-wrap]').hidden = false;
  root.querySelectorAll('.psu-categories a').forEach(link => link.addEventListener('click', () => {
    if (search.value) { search.value = ''; filter(); }
  }));
  root.querySelectorAll('[data-psu-chat]').forEach(button => button.addEventListener('click', () => {
    const feedback = root.querySelector('[data-psu-chat-status]');
    const launcher = document.getElementById('pino-concierge')?.shadowRoot?.querySelector('.launcher');
    if (launcher) {
      feedback.hidden = true;
      if (launcher.getAttribute('aria-expanded') !== 'true') launcher.click();
      document.getElementById('pino-concierge').shadowRoot.querySelector('textarea')?.focus({ preventScroll: true });
    } else {
      feedback.textContent = root.dataset.chatUnavailable;
      feedback.hidden = false;
      feedback.scrollIntoView({ block: 'nearest' });
    }
  }));
})();
